import { ValidatorFn, AbstractControl, FormGroup } from '@angular/forms';
import { Constants } from 'src/app/core/enums/constants.enum';
import { getDateAfterNDays } from 'src/app/util/util';

export function positiveNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const isNotOk = Number(control.value) < 0;
        return isNotOk ? { nonPositive: { value: control.value } } : null;
    };
}

export function greaterThanZero(allowNullOrEmptyString: boolean = true): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        let isNotOk = false;
        if (allowNullOrEmptyString) {
            isNotOk = control.value !== null && control.value !== undefined && control.value !== '' && +control.value <= 0;
        } else {
            isNotOk = control.value === null || control.value === undefined || +control.value <= 0;
        }
        return isNotOk ? { greaterThanZero: { value: control.value } } : null;
    };
}

export function nonZeroNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        const isNotOk = Number(control.value) <= 0;
        return isNotOk ? { nonPositive: { value: control.value } } : null;
    };
}

export function lessThanLimit(
    limit: number,
    allowNull: boolean = true
): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
        let isNotOk = false;

        if (allowNull) {
            isNotOk = control.value !== null && +control.value > limit;
        } else {
            isNotOk = control.value === null || +control.value > limit;
        }
        return isNotOk
            ? { lessThanLimit: { value: control.value, limit: limit } }
            : null;
    };
}

export function validateUnderCondition(
    validatorFn: ValidatorFn,
    conditionFn: () => boolean
): ValidatorFn {
    return (control: AbstractControl) => {
        if (!conditionFn()) {
            return null;
        }
        return validatorFn(control);
    };
}

export function flightScheduleDateValidator(): ValidatorFn {
    return (fg: FormGroup) => {
        let startDate = fg.get('startDate').value;
        let endDate = fg.get('endDate').value;
        let timezone = localStorage.getItem(Constants.MARKET_TIMEZONE);
        let plus60DaysDate = getDateAfterNDays(60, timezone ? JSON.parse(timezone) : '');
        startDate = typeof startDate === "string" ? Date.parse(startDate) : startDate;
        endDate = typeof endDate === "string" ? Date.parse(endDate) : endDate;
        //86400000(24*60*60*1000) is milisecond of 1 day
        return startDate !== null && endDate !== null && startDate < endDate
            ? (endDate - startDate) >= 86400000 ?
                (startDate > plus60DaysDate || endDate > plus60DaysDate) ? { invalidStartOrEndDateRange: true } : null
                : { invalidDateRange: true }
            : { invalidDate: true };
    };
}

export function frequencyCapValidator(): ValidatorFn {
    return (fg: FormGroup) => {
        const val = fg.get('value').value;
        const period = fg.get('period').value;
        return (val === undefined || val === '' || val === null) && (period === undefined || period === '' || period === null) || val && val > 0 && period && period > 0 ? null : { invalidFrequency: true };
    }
}
